import { createFileRoute } from '@tanstack/react-router';
import { useLingui } from '@lingui/react/macro';
import { PagePending } from './-components/page-pending';

export const Route = createFileRoute('/new/about-us')({
	component: Component,
});

function Component() {
	const { t } = useLingui();
	return <PagePending title={t`About Us`} />;
}
